<template>
  <section>
    <v-sheet max-width="800" class="mx-auto mt-12">
      <h1 class="display-1">Liens Formulaires</h1>
      <p>{{ version }}</p>
      <v-text-field outlined v-model="contactId" label="Contact ID" dense></v-text-field>
      <v-text-field outlined v-model="recherche" label="Recherche" dense></v-text-field>
      <p>{{ routesFiltrees.length }} de {{ routes.length }}</p>
      <div v-for="route in routesFiltrees" :key="route.id">
        <a :href="'#' + route.path + '?contactId=' + contactId" class="py-1 d-block">{{ route.path }}</a>
      </div>
    </v-sheet>
  </section>
</template>

<script>
import Router from "@/router/index.js"
import { version } from "@/../package.json"
export default {
  data() {
    return {
      contactId: "gE77ics6ZAT03hlKIiMFDwR1EpL1R1EpL1",
      recherche: ""
    }
  },
  created() {},
  computed: {
    version() {
      return version
    },
    routes() {
      if (Router) {
        return Router.options.routes.filter((x) => !x.path.includes(":"))
      }
      return []
    },
    routesFiltrees() {
      if (Router) {
        return this.routes.filter((x) => x.path.includes(this.recherche))
      }
      return []
    }
  }
}
</script>

<style>
</style>